/* unplugin-vue-components disabled */import script from "./LessonUnlinkIn.vue?vue&type=script&setup=true&lang=js"
export * from "./LessonUnlinkIn.vue?vue&type=script&setup=true&lang=js"

import "./LessonUnlinkIn.vue?vue&type=style&index=0&id=54c432a7&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54c432a7"]])

export default __exports__